/**
 * compnay.ts
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 시행사 표출 데이터입니다.
 * Footer 바로 위에 활성화 되는 정보입니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

export const dataCompany = [
    {
        title: "시행사 : ",
        desc : "대신자산신탁㈜"
    },
    {
        title: "위탁사 : ",
        desc : "주식회사 부림"
    },
    {
        title: "시공사 : ",
        desc : "DL건설"
    }
];